import Box from '@mui/material/Box'
import CircularProgress, {
  CircularProgressProps
} from '@mui/material/CircularProgress'

import { FC, ReactElement } from 'react'

interface MoovyProgressProps extends CircularProgressProps {
  success?: boolean
}

const MoovyProgress: FC<MoovyProgressProps> = (props): ReactElement | null => {
  const {
    success = false,
    ...restProps
  } = props

  const style = restProps.sx || {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  }

  if (success) {
    return null
  }

  return (
    <Box sx={style}>
      <CircularProgress {...restProps} />
    </Box>
  )
}

export default MoovyProgress
